// extracted by mini-css-extract-plugin
export default {"root":"Main_root__f+jqs","inputsContent":"Main_inputsContent__exP6e","title":"Main_title__FWpWq","inputsGroup":"Main_inputsGroup__X6sKk"};